(function ($, window) {
    $(document).ready(init);

    /**
     * Handle scrolling down from the different heroes
     */
    function init() {
        var $downButton = $('.image-hero__down, .image-hero__read, .text-hero__down, .blog-hero__down');
        $downButton.click(function () {
            $("html, body").animate({scrollTop: $(this).parents('.widgetSection').innerHeight()}, 600);
        });
    }

})(jQuery, window);